// extracted by mini-css-extract-plugin
module.exports = {"delivery_indicator":"styles_delivery_indicator__CTLbb","badge":"styles_badge__rI6K1","blue":"styles_blue__EImrY","green":"styles_green__w4VO0","purple":"styles_purple__LxRSq"};